export var currentVideoDetails = function currentVideoDetails(state) {
  return state.video.details;
};
export var videoDetailMode = function videoDetailMode(state) {
  return state.video.detailMode;
};
export var videoCompleted = function videoCompleted(state) {
  return state.video.completed;
};
export var leaderboardJoin = function leaderboardJoin(state, alias) {
  return state.entities.leaderboardJoinClass.loaded[alias];
};
export var trackingId = function trackingId(state) {
  return state.entities.videoTracking.data.default && state.entities.videoTracking.data.default.video_event_id;
};
export var videoIdTracked = function videoIdTracked(state) {
  return state.entities.videoTracking.data.default && state.entities.videoTracking.data.default.video_id;
};
export var videoPercentPlayed = function videoPercentPlayed(state) {
  return state.video.percentPlayed;
};
export var videoMetadata = function videoMetadata(state) {
  return state.video;
};